export enum MESSAGE_TOAST {
    ADD_FILE_SUCCESS = 'File was added successfully',
    ADD_ADMIN_SUCCESS = 'Admin was added successfully',
    CHANGE_ACTIVE_APPLICATION_SUCCESS = 'Application is showed',
    CHANGE_ACTIVE_HIDDEN_APPLICATION_SUCCESS = 'Application is hidden',
    SUBMIT_SUPPLIER_ID_SUCCESS = 'Supplier ID was added successfully',
    REQUEST_ACCESS_TICKET_SUCCESS = 'Request Access is sent successfully',
    REQUEST_ACCESS_TICKET_FAILED = 'Request Access is sent failed',
    ADD_DOCUMENT_TRAINING_DETAIL_SUCCESS = 'Application Training Documents are added successfully',
    EDIT_DOCUMENT_TRAINING_DETAIL_SUCCESS = 'Application Training Documents Detail saved',
    UPDATE_WELCOME_MESAGE_SUCCESS = 'Welcome message has been updated successfully',
    ADD_SECTION_SUCCESS = 'Section has been created successfully',
    UPDATE_SECTION_SUCCESS = 'Section has been updated successfully',
    DELETE_SECTION_SUCCESS = 'Section has been deleted successfully',
    ADD_APPLICATION_LINK = 'Application Link has been created successfully',
    UPDATE_APPLICATION_LINK = 'Application Link has been updated successfully',
    DELETE_APPLICATION_LINK = 'Application Link has been deleted successfully',
    ACTIVATED_SUPPLIER = 'User has been activated successfully',
    DEACTIVATED_SUPPLIER = 'User has been deactivated successfully',
    ADD_SUPPLIER_SUCCESS = 'Supllier has been created successfully',
    ADD_INTERNAL_USER_SUCCESS = 'Internal user has been created successfully',
    EDIT_SUPPLIER_SUCCESS = 'Supllier has been updated successfully',
    EDIT_INTERNAL_USER_SUCCESS = 'Internal user has been updated successfully',
    ADD_NEWS = 'News has been created successfully',
    DELETE_NEWS = 'News has been deleted successfully',
    EDIT_NEWS = 'News has been updated successfully',
    ACTIVATED_NEWS = 'News has been publish successfully',
    DEACTIVATED_NEWS = 'News has been deactivated successfully',
    ADD_ROLES = 'Role has been created successfully',
    UPDATE_ROLES = 'Role has been updated successfully',
    DELETE_ROLE = 'Role has been deleted successfully',
    CHANGED_GROUP_NAME = 'Group name has been updated successfully',
    ADD_STAY_INFORMED = 'Stay Informed has been created successfully',
    EDIT_STAY_INFORMED = 'Stay Informed has been updated successfully',
    DELETE_STAY_INFORMED = 'Stay Informed has been deleted successfully',
    DELETE_USER = 'User has been deleted successfully',
    ADD_SCORECARD_SETTING = 'KPI Configuration has been created successfully',
    EDIT_SCORECARD_SETTING = 'KPI Configuration has been updated successfully',
    DELETE_SETTING = 'KPI configuration has been deleted successfully',
    UPLOAD_RATING_GUIDELINE = 'Rating Guideline has been updated successfully',

    ERROR_ADMIN_EXIST = 'This SSO ID is already added',
    ERROR_SESSION_TIME_OUT = 'Your session has expired. Please log in again to continue',
    ERROR_SAVE_FILE = 'Please save document file',
    ERROR_CHOOSE_FILE_DOC_SIZE = 'Choose file max size not larger than 10MB',
    ERROR_CHOOSE_FILE_DOC = 'Please choose one of the following file types: jpg, pdf, doc, docx, xls, xlsx, ppt, pptx',
    ERROR__FILE_UPLOAD = 'Sorry, file could not be uploaded at the moment! Please try again later',
    DELETE_FILE = 'File is deleted successfully',
    DELETE_ADMIN_SUCCESS = 'Admin ID is deleted successfully',
    DELETE_APPLICATION_SUCCESS = 'Application is deleted successfully',

    CONFIRM_SUBMIT_SUPPLIER_ID = 'Save your Supplier ID?',
    CONFIRM_ADD_ADMIN = 'Are you sure you want to add this Admin?',
    CONFIRM_CHANGE_ACTIVE_APPLICATION = 'Change Application activation status?',
    CONFIRM_DELETE_ADMIN = 'Are you sure you want to delete this Admin?',
    CONFIRM_DELETE_RESOURCE = 'Are you sure you want to delete this file?',
    CONFIRM_ADD_APPLICATION = 'Are you sure you want to add this Application?',
    CONFIRM_DELETE_APPLICATION = 'Are you sure you want to delete this Application?',
    CONFIRM_REQUEST_ACCESS = 'Are you sure you want to request access to this Application?',
    CONFIRM_TAG_STATUS = 'Are you sure you want to submit the details & request for GE Tag IDs',
    CONFIRM_TAG_STATUS_UPDATE= 'Are you sure you want to update the Tag Incident Status?',
    CONFIRM_DELETE_SECTION = 'Are you sure you want to delete to this Section?',
    CONFIRM_CHANGE_DEACTIVE = 'Are you sure you want to deactive to this User ?',
    CONFIRM_CHANGE_ACTIVE = 'Are you sure you want to active this User?',
    CONFIRM_CHANGE_ACTIVE_NEWS = 'Are you sure you want to active this news?',
    CONFIRM_CHANGE_DEACTIVE_NEWS = 'Are you sure you want to deactive this news?',
    CONFIRM_DELETE_NEWS = 'Are you sure you want to delete to this News?',
    CONFIRM_DELETE_ROLE = 'Are you sure you want to delete to this Role?',
    CONFIRM_DELETE_STAY_INFORMED = 'Are you sure you want to delete to this stay informed?',
    CONFIRM_DELETE_USER = 'Are you sure you want to delete this user?',
    CONFIRM_DELETE_SETTING = 'Are you sure you want to delete this KPI configuration?',
    CONFIRM_DELETE_RECORD = 'Are you sure you want to delete this record?',
    CONFIRM_SUBMIT_RECORD = 'Are you sure you want to submit this record?',
    DELETE_RECORD_SUCCESS = 'Record has been deleted successfully',

    FORBIDDEN = 'You are forbidden to perform this operation',
    ACCESS_DENIED = 'Access is denied due to invalid credentials!',
    INTERNAL_SERVER_ERROR = 'The requested service is not available at the moment. Please try again later!',
    GSL_INFO_REQUIRED = 'GSL information is required',
    GSL_DUPLICATED_INFO = 'GSL information is duplicated',
    GSL_DIFFERENT_COMPANY_NAME = 'GSL information is different parent company',
    GSL_DIFFERENT_SUPPLIER_TYPE = 'GSL information is different supplier type',
    GSL_NUMBER_REQUIRED = 'GSL Number is required',
    GSL_SUPPLIER_NAME_REQUIRED = 'Supplier Name is required',
    GSL_PARENT_COMPANY_REQUIRED = 'Parent Company Name is required',
    GSL_SITE_NUMBER_REQUIRED = 'Site Number is required',
    SSO_NOT_FOUND = 'SSO is not found',
    FILE_TYPE_WRONG = 'This file type cannot be selected',
    OPERATORS_WRONG  = 'Operators cannot be the same',
    SCORING_WRONG  = 'The Scoring (Weighted) should not be greater than max',
    BEHAVIOR_SCORING_NOTVALID  = 'The Behavior Scoring (Weighted) should be 85',
    PERFORM_SCORING_NOTVALID  = 'The Performance Scoring (Weighted) should be 115',
    SCORING_NEGATIVE  = 'The Scoring (Weighted) should not be negative',
    PARENT_COMPANY_GSL_REQUIRED  = 'Parent company or GSL Number is required',
    RSPROLE_OR_CONTRACTROLE_IS_REQUIRED = 'RSP Role or Contract Role is required',
    DOWNLOAD_OTD = 'You just only download file when Consider Commodity is NO',
    CONTRACT_SAVE_MASS_SUCCESS = 'File successfully mass uploded',
    CONTRACT_SAVE_MASS_ERROR = 'File could not be uploaded',

    FILE_MISSING = 'Please upload Tag Request Template and try again!',
    ERROR_DOWNLOAD_FILE = 'File couldn\'t be downloaded at the moment, please try again later!',

    CREATE_SUPPLIER_FORM_SUCCESS = 'Supplier is created successfully',
    UPDATE_SUPPLIER_FORM_SUCCESS = 'Supplier is updated successfully',
    
    CREATE_FIBERGLASS_SUCCESS = 'Processing method is created successfully',
    UPDATE_FIBERGLASS_FORM_SUCCESS = 'Processing method is updated successfully',

}